export default [{
  name: 'Infrastructure',
  value: 1,
  label: 'Infrastructure<br>1%',
  color: 'red',
  group: 'Infrastructure',
  offset: 0,
  opacity: 1,
  align: 'left'
}, {
  name: 'Irrigated cropland',
  value: 2,
  label: 'Irrigated cropland<br>2%',
  color: 'yellow',
  group: 'Cropland',
  offset: -16,
  opacity: 1,
  align: 'left'
}, {
  name: 'Non-irrigated cropland',
  value: 10,
  label: 'Non-irrigated cropland<br>10%',
  color: 'yellow',
  group: 'Cropland',
  offset: 16,
  opacity: 0.5,
  align: 'center'
}, {
  name: 'Intensive pasture',
  value: 2,
  label: 'Intensive pasture<br>2%',
  color: 'green',
  group: 'Grazing land',
  offset: -32,
  opacity: 1,
  align: 'center'
}, {
  name: 'Used savannahs and shrublands',
  value: 16,
  label: 'Used savannahs and<br>shrublands 16%',
  color: 'green',
  group: 'Grazing land',
  offset: 0,
  opacity: 0.66,
  align: 'center'
}, {
  name: 'Extensive pasture',
  value: 19,
  label: 'Extensive pasture<br>19%',
  color: 'green',
  group: 'Grazing land',
  offset: 32,
  opacity: 0.33,
  align: 'center'
}, {
  name: 'Plantation forests',
  value: 2,
  label: 'Plantation forests<br>2%',
  color: 'blue',
  group: 'Used forests',
  offset: -16,
  opacity: 1,
  align: 'center'
}, {
  name: 'Managed forests',
  value: 20,
  label: 'Forests managed for timber<br>and other uses 20%',
  color: 'blue',
  group: 'Used forests',
  offset: 16,
  opacity: 0.5,
  align: 'center'
}, {
  name: 'Unforested ecosystems',
  value: 7,
  label: 'Unforested ecosystems with<br>minimal human use 7%',
  color: 'purple',
  group: 'Unused land',
  offset: -32,
  opacity: 1,
  align: 'right'
}, {
  name: 'Forests',
  value: 9,
  label: 'Forests with minimal<br>human use 9%',
  color: 'purple',
  group: 'Unused land',
  offset: 0,
  opacity: 0.66,
  align: 'right'
}, {
  name: 'Other land',
  value: 12,
  label: 'Other land 12%',
  color: 'purple',
  group: 'Unused land',
  offset: 32,
  opacity: 0.33,
  align: 'right'
}]
